import { jsxs, jsx } from "react/jsx-runtime";
import Group from "../../../../../layout/Group/Group.js";
import Paragraph from "../../../../../typography/Paragraph/Paragraph.js";
import Grid from "../../../../../layout/Grid/Grid.js";
import Button from "../../../../../buttons/Button/Button.js";
import { useLocaleText } from "../../../../../../hooks/useLocaleText.js";
import '../../../../../../assets/OtherSites.css';const navigation = "_navigation_qkj4d_2";
const container = "_container_qkj4d_23";
const bottomWrapper = "_bottomWrapper_qkj4d_68";
const bottomText = "_bottomText_qkj4d_75";
const bottomLinks = "_bottomLinks_qkj4d_81";
const FullscreenNavStyles = {
  navigation,
  container,
  bottomWrapper,
  bottomText,
  bottomLinks
};
const OtherSites = ({ globalLinks }) => {
  const texts = useLocaleText();
  return globalLinks && globalLinks.length > 0 && /* @__PURE__ */ jsxs(Group, { justify: "center", className: FullscreenNavStyles.bottomWrapper, children: [
    /* @__PURE__ */ jsx(
      Paragraph,
      {
        variant: "light",
        align: "center",
        transform: "uppercase",
        text: texts.visitOtherSites,
        className: FullscreenNavStyles.bottomText
      }
    ),
    /* @__PURE__ */ jsx(Grid, { container: true, spacing: "xs", className: FullscreenNavStyles.bottomLinks, children: globalLinks.map((globalLink, globalLinkIndex) => /* @__PURE__ */ jsx(
      Button,
      {
        text: globalLink.text,
        href: globalLink.href,
        variant: "outline",
        contrast: "dark",
        icon: "ArrowUpRight",
        iconPosition: "right"
      },
      `link${globalLinkIndex}`
    )) })
  ] });
};
export {
  FullscreenNavStyles as F,
  OtherSites as default
};
